<template>
    <div class="cloudPosPre" @click="isCartShow=false">
        <!-- 顶部导航栏 -->
        <div class="header-box">
            <div class="header-left">
                <div class="flex-box">
                    <lunar-calendar class="calendar-box"
                        v-model="ydDate"
                        :minDate="new Date()"
                        type="date"
                        placeholder=""
                        @change="lunarChange">
                        <div class="icon">
                            <i class="iconfont icon-rili1"></i>
                        </div>
                        <div class="text">{{ydDate}}</div>
                    </lunar-calendar>
                    <div class="today_bnt" :class="{selected:ydDate==toDay}" @click="clickToDay()">今 &nbsp; 日</div>
                    <swiper-date :date="ydDate" @change="calendarChange"/>
                </div>
            </div>
            <div class="phase-list">
                <div class="item-box" :class="{selected:item.PhaseID==ydPhaseID}" @click="changePhase(item)"
                    v-for="item in reserveData?.PhasePeriodStatsList" :key="item">
                    <div class="tag selected" v-if="item.type==2">当前</div>
                    <div class="tag" v-else-if="item.type==1">已过</div>
                    <div class="name nowrap2">{{item.PhaseName}}</div>
                    <div class="info-box nowrap">
                        <i class="iconfont icon-dingdan1"></i>
                        {{item.OrderCount}}单{{item.TotalTables}}桌{{item.PersonCount}}人
                    </div>
                    <div class="info-box nowrap" style="margin-top:16rpx">
                        空桌: 
                        <span v-for="deskType in item.PhasePeriodDeskTypes" :key="deskType">
                            {{deskType.DeskType_Name}}/{{deskType.EmptyTables}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="right-bnts">
                <div class="bnt" @click="loadData()">
                    <i class="iconfont icon-shuaxin"></i>
                    <div class="name">刷新</div>
                </div>
                <template v-if="isWindow">
					<div class="bnt" v-if="$global.isFull"  @click="formMax()">
                        <i class="iconfont icon-tuichuquanping"></i><div class="name">退出全屏</div>
                    </div>
					<div class="bnt" v-else @click="formFull()">
                        <i class="iconfont icon-quanping"></i><div class="name">全屏</div>
                    </div>
				</template>
                <div class="bnt" @click="back()">
                    <i class="iconfont icon-chexiao"></i>
                    <div class="name">返回</div>
                </div>
            </div>
        </div>

        <!-- 主内容区 -->
        <div class="main-content">
            <!-- 左侧预订列表 -->
            <div class="left-panel">
                <div class="mask" v-show="editDeskType>0"></div>
                <div class="nav-box"> 
                    <div class="li-bnt" :class="{selected:navIndex==0}" @click="navIndex=0">
                        <div class="name">
                            <i class="iconfont icon-dingdan1"></i>预订订单
                        </div>
                        
                    </div>
                    <div class="li-bnt" :class="{selected:navIndex==1}" @click="navIndex=1">
                        <div class="name">
                            <i class="iconfont icon-dianhua11"></i><span class="name">来电记录</span>
                        </div>
                        <div class="num" v-if="$refs.talTecord?.notReadCount>0">{{$refs.talTecord?.notReadCount}}</div>
                    </div>
                </div>
                <div class="panel-box" v-show="navIndex==0">
                    <div class="search-bar">
                        <key-board-input class="search"
                            type="text" v-model="filter.searchText" placeholder="输入客户姓名、手机号、桌号检索"
                            isKeyEnterClose isBlurClose 
                            :keyOptions="{isKeyDownEnter:true}"
                        ></key-board-input>
                        <el-select v-model="filter.salesman" placeholder="销售员">
                            <el-option label="全部销售员" value="" />
                            <el-option v-for="item in sellersList" :key="item" :label="item.User_Name" :value="item.User_Name"/>
                        </el-select>
                        <el-select v-model="filter.restaurant" placeholder="餐厅">
                            <el-option v-for="item in roomGroup" :key="item" :label="item.text" :value="item.value" />
                        </el-select>
                        <el-select v-model="filter.status" placeholder="订单状态">
                            <el-option label="全部" value="" />
                            <el-option v-for="item in orderStatusList" :key="item" :label="item.name" :value="item.value"/>
                        </el-select>
                    </div>
                    <div class="sort-bar">
                        <span class="sort-label">排序：</span>
                        <div class="sort-pill" :class="{selected:'isPreOrTime'==orderSort?.key}" @click="toggleSort('isPreOrTime')">
                            预订优先<span class="sort-arrow">{{orderSort.type=="asc"?'↑':'↓'}}</span>
                        </div>
                        <div class="sort-pill" :class="{selected:'Desk_Name'==orderSort?.key}" @click="toggleSort('Desk_Name')">
                            桌台<span class="sort-arrow">{{orderSort.type=="asc"?'↑':'↓'}}</span>
                        </div>
                        <div class="sort-pill" :class="{selected:'Eat_Sales'==orderSort?.key}" @click="toggleSort('Eat_Sales')">
                            销售员<span class="sort-arrow">{{orderSort.type=="asc"?'↑':'↓'}}</span>
                        </div>
                        <div class="sort-pill" :class="{selected:'Eat_PreTime'==orderSort?.key}" @click="toggleSort('Eat_PreTime')">
                            抵达时间<span class="sort-arrow">{{orderSort.type=="asc"?'↑':'↓'}}</span>
                        </div>
                    </div>

                    <div class="booking-list" ref="booking" v-mouse-scroll>
                        <div class="booking-item" :class="{selected:currentOrder==item.Eat_PreAutoID}"
                            v-for="(item, index) in orderListSort" :key="index" :data-id="item.Eat_PreAutoID">
                            <template v-if="item.Eat_PreAutoID">
                                <div class="tag_type" v-if="item.ReserveStatus==1">客到</div>
                                <div class="tag_type selected" v-else>订</div>
                            </template>
                            <!-- <div class="yijiez" v-if="item.Status==4"><i class="iconfont icon-a-weiqueren11"></i></div> -->
                            <div class="top-right">
                                <!-- <div class="tag tag-ding" v-if="!item.Is_Desk_Locked && item.Is_ReserveOrder">订</div> -->
                                <div class="tag tag-timeout" v-if="item.isTimeOut">
                                    <i class="iconfont icon-chaoshi1"></i>
                                </div>
                                <div class="tag tag-dingjin" v-if="item.IsDepositReceived">
                                    <i class="iconfont icon-xiaofei"></i>
                                </div>
                                <div class="tag tag-dianhua" v-if="item.ArrivalConfirmCount>0">
                                    <i class="iconfont icon-dianhua1"></i>
                                </div>
                                <div class="tag tag-huiyuan" v-if="item.IsVip">
                                    <i class="iconfont icon-huiyuan1"></i>
                                </div>
                            </div>
                            <div class="flex-box" @click="currentOrder=currentOrder==item.Eat_PreAutoID?'':item.Eat_PreAutoID">
                                <div class="left-content">
                                    <div class="room-name">
                                        <span class="name">{{ item.Desk_Name }} </span>
                                        <span>({{ item.Eat_ManNum }}人)</span>
                                    </div>
                                    <div class="tr">
                                        <i class="iconfont icon-a-zhibantongji1"></i>
                                        {{timeFormat(item.Eat_PreTime)}}到 &nbsp; <span class="red" v-if="item.isTimeOut"><i class="iconfont icon-a-chaoshi1"></i> (超{{Math.ceil(item.timeOut/60)}}分)</span>
                                    </div>
                                    <div class="tr">
                                        <i class="iconfont icon-a-fuwuyuan1"></i>
                                        {{item.Eat_Sales}} 订
                                    </div>
                                    <div class="tr" v-if="item.ReserveDesks?.length>1">
                                        <i class="iconfont icon-canzhuoguanli"></i>
                                        共{{item.ReserveDesks?.length||0}}桌: {{item.ReserveDesks?.map(it=>it.Eat_DeskName)?.join('、')}}
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="room-name">
                                        <span class="name">{{item.Cstm_Name}}</span>&nbsp;
                                        <span class="unit">{{item.Cstm_Sex?"先生":"女士"}}</span> &nbsp;
                                        <span><i class="iconfont icon-shouji"></i>{{blurPhone(item.Cstm_Mobile)}}</span>
                                        <span class="tag-party">{{item.XfType_Name}}</span>
                                    </div>
                                    <div class="tr">
                                        【{{item.Order_Type==1?'普通预订':'宴会预订'}}】
                                        <span v-if="item.Eat_Bz">备注：{{item.Eat_Bz}}</span>
                                    </div>
                                    <div class="tr" v-if="item.Client_Habits">
                                    【客户喜好】<span class="red">{{item.Client_Habits}}</span>
                                    </div>
                                    <div class="tr" v-if="item.Client_Taboo">
                                    【客户忌口】<span class="red">{{item.Client_Taboo}}</span>
                                    </div>
                                    <!-- <div class="tr" v-if="item.Status==4">
                                        消费金额：<span class="red">￥{{item.Eat_SaleMoney||0}}</span>
                                    </div> -->
                                </div>
                            </div>
                            
                            <div class="item-footer" v-show="currentOrder==item.Eat_PreAutoID">
                                <div class="bnt" @click="orderEdit(item)">查看订单</div>
                                <template v-if="!item.ReserveDesks.some(it=>it.Desk_Status!=2)">
                                    <div class="bnt" @click="gouXuanOrderDesk(item)">定位桌台</div>
                                    <div class="bnt" @click="cancelReserve(item)">退订</div>
                                    <div class="bnt" @click="confirmBeforeMeal(item)" v-if="!(item.Order_Check>0)">餐前确认</div>
                                    <div class="bnt" @click="markVip(false,item)" v-if="item.IsVip">取消VIP</div>
                                    <div class="bnt" @click="markVip(true,item)" v-else>标记VIP</div>
                                </template>
                            </div>
                            <div class="more">
                                <i class="iconfont icon-a-order-down"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 电话记录 -->
                <tal-record-box ref="talTecord" class="panel-box" v-show="navIndex==1"/>
            </div>

            <!-- 右侧区域视图 -->
            <div class="right-panel">
                
                <div class="panel-box">
                <!-- 日期标题 -->
                <div class="date-title">
                    <div class="flex1">
                        <span class="yd-title">{{ydTitle}}</span> 
                        <span class="total">空桌：
                            <span v-for="deskType in deskTypes" :key="deskType">
                                {{deskType.DeskType_Name}}/<span class="num">{{deskType.EmptyTables}}</span> &nbsp;
                            </span>
                        </span>
                    </div>
                    <div class="date-display nowrap">
                        <img class="icon" src="/images/laba.png"/>日报：{{new Date(ydDate).Format('MM月dd日')}}（{{lunarDate?.dateStr}}）
                        已预订{{reserveData?.TotalOrders||0}}单{{reserveData?.TotalTables||0}}桌{{reserveData?.TotalPersons||0}}人
                    </div>
                </div>

                <!-- 搜索和筛选 -->
                <div class="right-search">
                    <div class="flex1">
                        <key-board-input class="search"
                            type="text" v-model="deskSearchTxt" placeholder="输入客户姓名、手机号、桌号检索"
                            isKeyEnterClose isBlurClose 
                            :keyOptions="{isKeyDownEnter:true}"
                        ></key-board-input>
                    </div>
                    <el-switch v-model="isDeskEmpty" active-text="只看空台" active-color="#22983E"/>
                    <el-select v-model="rowNum">
                        <el-option label="4列" :value="4" />
                        <el-option label="5列" :value="5" />
                        <el-option label="6列" :value="6" />
                        <el-option label="7列" :value="7" />
                        <el-option label="8列" :value="8" />
                        <el-option label="9列" :value="9" />
                        <el-option label="10列" :value="10" />
                    </el-select>
                </div>

                <div class="filter-nav">
                    <!-- 区域分类 -->
                    <div class="nav-box scrollnot" v-mouse-scroll ref="nav"
                        v-scroll-anime="{up:'nav-up',down:'nav-down',fx:'x',liClass:'.nav-li',page:'deskPage',isNavFirstSticky:true}">
                        <div class="nav-li selected" data-index="0">
                            <div class="name">全部</div>
                        </div>
                        <div class="nav-li" v-for="(item,index) in roomGroupList" :key="item" :data-index="index">
                            <div class="name">{{item.Room_Name}}</div>
                        </div>
                    </div>

                    <!-- 分页 -->
                    <div class="page-box">
                        <div class="last-page" ref="nav-up"><i class="iconfont icon-fangxiangquan-left"></i></div>
                        <span class="page-number">{{deskPage.pageIndex}}/{{deskPage.pageSize}} 页</span>
                        <div class="next-page" ref="nav-down"><i class="iconfont icon-fangxiangquan-right"></i></div>
                    </div>
                </div>

                <!-- 表格区域 -->
                <div class="tables-container" :style="{'--rowNum':rowNum}" ref="scroll" v-mouse-scroll v-nav-roll="{nav:'nav',paneName:'.room-box'}">
                    <div class="desk-box">
                        <div class="room-box" v-for="group in roomGroupList" :key="group">
                            <div class="group-name">{{group.Room_Name}}</div>
                            <div class="grid-box">
                                <div class="li-box" :class="{
                                        opening:item.Desk_Status==1,
                                        reserve:item.Desk_Status==2 && !item.Is_Desk_Locked,
                                        preKnot:item.Desk_Status==3,
                                        overtime:item.Desk_Status==4,
                                        disabled:item.isDisabled
                                    }" :data-id="item.Reserve_OrderID"
                                    v-for="item in group.list" :key="item" @click="addCart(item,true)">
                                    <div class="type">{{item.ReserveTypeName}}</div>
                                    <div class="top">
                                        <div class="tag tag-ding" v-if="!item.Is_Desk_Locked && item.Is_ReserveOrder">订</div>
                                        <div class="flex1"></div>
                                        <div class="tag-suo" v-if="item.Is_Desk_Locked">
                                            <i class="iconfont icon-suo"></i>
                                        </div>
                                        
                                        <div class="tag tag-timeout" v-if="!item.Is_Desk_Locked && item.isTimeOut">
                                            <i class="iconfont icon-chaoshi1"></i>
                                        </div>
                                        <div class="tag tag-dingjin" v-if="item.IsDepositReceived">
                                            <i class="iconfont icon-xiaofei"></i>
                                        </div>
                                        <div class="tag tag-dianhua" v-if="item.ArrivalConfirmCount>0">
                                            <i class="iconfont icon-dianhua1"></i>
                                        </div>
                                        <div class="tag tag-huiyuan" v-if="item.IsVip">
                                            <i class="iconfont icon-huiyuan1"></i>
                                        </div>
                                    </div>
                                    <div class="name">
                                        <div class="desk-name nowrap">{{item.Desk_Name}}</div>
                                        <div class="describe nowrap">
                                            <span v-if="!item.Is_Desk_Locked && item.Reserve_Seller">
                                                {{item.Reserve_Seller}}<template v-if="item.Is_ReserveOrder">订</template>
                                            </span>
                                            <span class="red" v-else-if="item.Is_Desk_Locked">原因:{{item.Desk_LockedReason}}</span>
                                        </div>
                                    </div>
                                    <div class="tr-box">
                                        <div class="flex1">
                                            <i class="iconfont icon-people"></i>
                                            <span v-if="item.Desk_Status==0 || item.Is_Desk_Locked">{{item.Seat_Numbers||0}}</span>
                                            <span v-else-if="item.PersonNum>0">{{item.PersonNum}}人</span>
                                            <span v-else>0</span>
                                        </div>
                                        <div class="flex1 right">
                                            <span v-if="!item.Is_Desk_Locked && item.Desk_Status==2">
                                                {{timeFormat(item.Reserve_CheckIn_Time)}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="tr-box">
                                        <div class="flex1" v-if="item.Cstm_Mobile">
                                            <i class="iconfont icon-shouji"></i>
                                            <span>{{item.Cstm_Mobile.substring(item.Cstm_Mobile.length-4)}}</span>
                                        </div>
                                        <div class="flex1 right">
                                            <span v-if="item.Desk_Status==0 || item.Is_Desk_Locked">空闲<span v-if="!item.IsAllowReserve">(不可订)</span></span>
                                            <span v-else-if="!item.Is_Desk_Locked && item.Cstm_Name">{{item.Cstm_Name.substring(0,1)}}</span>
                                        </div>
                                    </div>
                                    <div class="gouxuan" v-if="cartDeskCheck[item.Desk_ID]">
                                        <i class="iconfont icon-gou1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 底部操作栏 -->
                <div class="bottom-bar edit-box" v-if="editDeskType>0">
                    <div class="cartDeskEdit-box">
                        <div class="num" v-if="editDeskData.deskList.length>1">{{editDeskData.deskList.length}}</div>
                        <div class="name nowrap">【{{editDeskData.deskList.map(it=>it.Desk_Name).join("、")}}】</div>
                        <div v-if="editDeskData.deskList.length>1">批量换桌中</div>
                        <div v-else>{{editDeskType==2?'在进行加桌操作中':'在进行换桌操作中'}}</div>
                    </div>
                    <div class="flex1"></div>
                    <template v-if="editDeskType==2">
                        <div class="cancel-bnt" @click="cancelEdit()">放弃加桌</div>
                        <div class="add-bnt" @click="addReserveDesk()">确认加桌</div>
                    </template>
                    <template v-else-if="editDeskType==1 && editDeskData.deskList.length>1">
                        <div class="cancel-bnt" @click="cancelEdit()">放弃换桌</div>
                        <div class="add-bnt" @click="batChangeDesk()">确认换桌</div>
                    </template>
                    <div class="cancel-bnt" @click="cancelEdit()" v-else>放弃换桌</div>
                </div>
                <div class="bottom-bar" v-else>
                    <div class="cartDesk-box" v-show="isCartShow" @click.stop>
                        <div class="title">
                            <div class="name nowrap">已选桌台（共{{cartDeskList.length||0}}桌） </div>
                            <div class="close-bnt" @click="isCartShow=false"><i class="iconfont icon-a-guanbi11"></i></div>
                        </div>
                        <div class="list-box">
                            <div class="item-li" v-for="item in cartDeskList" :key="item">
                                <div class="name nowrap">{{item.Desk_Name}}</div>
                                <div class="close-bnt" @click="addCart(item)"><i class="iconfont icon-guanbi"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="selected-tables" @click.stop="isCartShow=!isCartShow">
                        <div class="num" v-if="cartDeskList.length>0">{{cartDeskList.length}}</div>
                        <i class="iconfont icon-yixuan"></i>
                    </div>
                    <div class="flex1"></div>
                    <template v-if="navIndex!=1">
                        <div class="deputy-bnt" v-if="deskOrderType==0 && isToDate" @click="clickOpenDask(1)">散客开台</div>
                        <div class="pre-bnt" v-if="deskOrderType==2 && isToDate" @click="clickOpenDask()">预订开台</div>
                        

                        <div class="deputy-bnt" v-if="deskOrderType==0 && isDeskCheckReserve" @click="lockDesk()">锁台</div>
                        <div class="deputy-bnt" v-else-if="deskOrderType==1" @click="unLockDesk()">解锁</div>

                        <template v-if="deskOrderType==2">
                            <div class="deputy-bnt" @click="cancelReserve()">退订</div>
                            <div class="deputy-bnt" @click="deskEdit(1)">换桌</div>
                            <div class="deputy-bnt" @click="deskEdit(2)">加桌</div>
                        </template>
                        
                        <div class="pre-bnt" @click="clickOrder()" v-if="deskOrderType==0 && isDeskCheckReserve"><i class="iconfont icon-tianjia1"></i>立即预订</div>
                        <div class="pre-bnt disabled" v-else><i class="iconfont icon-tianjia1"></i>立即预订</div>
                    </template>
                </div>
                </div>
            </div>
        </div>
        <!-- 创建预订单 -->
        <!-- <modal-load :isShow="isReserveEdit" :isUnload="true"> -->
            <reserve-edit-model :data="reserveParam" :isShow="isReserveEdit" @close="isReserveEdit=false" @confirm="reserveConfirm"/>
        <!-- </modal-load> -->
        <!-- 锁台/退订原因 -->
        <remark-model ref="reason" :title="reasonTitle" />
        <!-- 退订原因 -->
        <cancel-reserve-model ref="cancel" />
    </div>
</template>

<script>
import { timeToMinutes } from '/src/common'
import reserveEditModel from './reserveEditModel/reserveEditModel.vue'
import remarkModel from './remarkModel/remarkModel.vue'
import talRecordBox from './talRecordBox/talRecordBox.vue'
import cancelReserveModel from './cancelReserveModel/cancelReserveModel.vue'

export default {
    name: "cloudPosPre",
    components:{
        reserveEditModel,
        remarkModel,
        talRecordBox,
        cancelReserveModel
    },
    data() {
        return {
            /**是否是pc 设备 */
			isWindow:this.$webBrowser.isMobile.Windows,
            //今天
            toDay: (new Date()).Format('yyyy-MM-dd'),
            //当前时间
			DateNow: new Date(),
            navMenu:{
				'Order':{key:'Order',name:'点单',icon:'icon-yudiancan',tabIndex:0,url:'diningTable'},
				'Bill':{key:'Bill',name:'账单',icon:'icon-zhangdan',tabIndex:1,url:'bill'},
				'Member':{key:'Member',name:'会员',icon:'icon-huiyuan',tabIndex:2,url:'member'},
				'Report':{key:'Report',name:'报表',icon:'icon-baobiao',tabIndex:3,url:'report'},
				'Config':{key:'Config',name:'设置',icon:'icon-shezhi',tabIndex:4,url:'setup'},
				CloudPosPre:{key:'CloudPosPre',name:'预订',icon:'icon-yuding',tabIndex:5,url:'cloudPosPre'},
			},
            userNavMenu:[],
            //农历
            lunarDate:null,
            //预订日期
            ydDate: (new Date()).Format('yyyy-MM-dd'),
            //预订时段id
            ydPhaseID:"",
            //预订时段信息
            reserveData:null,
            //0 预订单列表  1来电记录
            navIndex:0,
            
            filter: {
                searchText:"",
                salesman: '',
                restaurant: '',
                status: ''
            },
            //排序
            orderSort:{
                key:"isPreOrTime",
                type:"desc"
            },
            //订单状态
			orderStatusList:[
				{name:'预订',value:1},
				{name:'客到',value:2},
                //{name:'未确认',value:3},
				{name:'超时',value:4}
			],
            //订单数据
            orderList:[],
            //当前选中的订单
            currentOrder:"",
            //只看空台
            isDeskEmpty:false,
            //桌台检索
            deskSearchTxt:"",
            //桌台基础数据
            roomData:[],
            //桌台分类页码
            deskPage:{
                pageIndex:1,
                pageSize:1
            },
            //默认 6列
			rowNum: this.$cacheData.get("cloudPosPre_rowNum")||6,
            //桌台数据
            reserveDeskList:[],
            //勾选桌台 弹层
            isCartShow:false,
            //已选桌台
            cartDeskList:[],
            cartDeskCheck:{},
            
            //桌台操作类型  1预订换桌 2预订加桌 3开台换桌
            //1 预订换桌 同时段 空台、预订台  非同时段 空台
            //2 预订加桌 只能同时段 空台
            //3 开台换桌 只能同时段 空台、预订台
            editDeskType:0,
            editDeskData:null,
            //编辑 或 新增 预订单 弹层
            isReserveEdit:false,
            //要新增 或 修改的 预订传参 数据
            reserveParam:null,
            //锁台理由 或 退订理由 标题
            reasonTitle:"",
        }
    },
    computed:{
        
        //筛选出 当前时段的 预订 订单
        reserveOrderList(){
            const orderList=[];
            if(this.reserveDeskList?.length>0){
                const group={};
                this.reserveDeskList.forEach(it=>{
                    if(it.Reserve_OrderID && !it.Is_Desk_Locked){//预订单 不是锁台
                        if(!group[it.Reserve_OrderID]){
                            
                            group[it.Reserve_OrderID]={
                                Eat_PreAutoID:it.Reserve_OrderID,
                                Cstm_AutoID:it.Cstm_AutoID,
                                Cstm_Name:it.Cstm_Name,
                                Cstm_Sex:it.Cstm_Sex,
                                Cstm_Mobile:it.Cstm_Mobile,
                                IsVip:it.IsVip,
                                IsMember:it.IsMember,
                                IsDepositReceived:it.IsDepositReceived,//是否收取订金
                                ArrivalConfirmCount:it.ArrivalConfirmCount,//确认次数
                                XfTypeId:it.XfTypeId,
                                XfType_Name:it.XfType_Name,//消费类型名称
                                ReserveChannel_ID:it.ReserveChannel_ID,
                                ReserveChannel_Name:it.ReserveChannel_Name,//渠道
                                Order_Type:it.Order_Type,//预订类型
                                Eat_ManNum:it.PersonNum,//预订人数
                                Eat_PreTime:it.Reserve_CheckIn_Time,//就餐时间
                                Client_Habits:it.Client_Habits,//喜好
                                Client_Taboo:it.Client_Taboo,//忌口，忌讳
                                isTimeOut:it.isTimeOut,//是否超时
                                timeOut:it.timeOut,//超时时间
                                Eat_Sales:it.Reserve_Seller,//预订销售员
                                Desk_Name:it.Desk_Name,
                                ReserveDesks:[]
                            }
                            orderList.push(group[it.Reserve_OrderID]);
                        }
                        if(it.Desk_Status==2){//预订
                            group[it.Reserve_OrderID].ReserveStatus=2;
                        }else if(group[it.Reserve_OrderID].ReserveStatus!=2){//开台
                            group[it.Reserve_OrderID].ReserveStatus=1;
                        }
                        group[it.Reserve_OrderID].ReserveDesks.push({
                            Eat_DeskID:it.Desk_ID,
                            Eat_DeskName:it.Desk_Name,
                            Eat_DeskCode:it.Desk_Code,
                            Eat_ManNum:it.PersonNum,//人数
                            Desk_Status:it.Desk_Status,//状态 0	空台、1开台、2预订、3预结、4超时、5清台
                            Eat_SaleMoney:it.Eat_SaleMoney,
                            Room_ID:it.Room_ID,//餐厅
                            Room_Name:it.Room_Name
                        })
                    }
                })
            }
            return orderList;
        },
        orderFilter(){
            let list=this.reserveOrderList||[];
            if(list.length>0){
                if(this.filter.salesman){
					list=list.filter(it=>it.Eat_Sales==this.filter.salesman);
				}
                if(this.filter.restaurant){//餐厅
                    list=list.filter(it=>it.ReserveDesks.some(desk=>desk.Room_ID==this.filter.restaurant));
                }
                if(this.filter.status>0){
                    let status=this.filter.status;
                    list=list.filter(it=>{
						if(status==1 && it.ReserveStatus==2){//已预订
							return true;
						}else if(status==2 && it.ReserveStatus==1){//已入座
							return true;
						}else if(status==3 && !(it.ArrivalConfirmCount>0)){//未确认
							return true;
						}else if(status==4 && it.isTimeOut){//超时
							return true;
						}
					});
                }
                if(this.filter.searchText.trim()){
					const text=this.filter.searchText.trim().toUpperCase();
					list=list.filter(it=>it.Cstm_Name.toUpperCase().indexOf(text)>=0 || it.Cstm_Mobile.toUpperCase().indexOf(text)>=0 || it.ReserveDesks?.some(desk=>desk.Eat_DeskName.toUpperCase().indexOf(text)>=0))
				}
            }
            return list;
        },
        //预订单 排序后 数据
        orderListSort(){
            let list=this.orderFilter||[];
            if(this.orderSort?.key){//排序
                
                list.sort((d1,d2)=>{
                    if(this.orderSort.key=="isPreOrTime"){//预订优先
                        if(d1.ReserveStatus!=d2.ReserveStatus){
                            //ASC 升序  DESC 降序 */
                            if(this.orderSort.type=="asc"){
                                return d1.ReserveStatus-d2.ReserveStatus;
                            }else{
                                return d2.ReserveStatus-d1.ReserveStatus;
                            }
                            
                        }else{
                            return this.dateToMinutes(d1.Eat_PreTime)-this.dateToMinutes(d2.Eat_PreTime);//抵达时间 升序 排序
                        }
                    }else if(this.orderSort.key=="Eat_PreTime"){
                        //ASC 升序  DESC 降序 */
                        if(this.orderSort.type=="asc"){
                            return this.dateToMinutes(d1.Eat_PreTime)-this.dateToMinutes(d2.Eat_PreTime);
                        }else{
                            return this.dateToMinutes(d2.Eat_PreTime)-this.dateToMinutes(d1.Eat_PreTime);
                        }
                    }else{
                        let name=this.orderSort.key;
                        let convertA = (d1[name]===undefined || d1[name]===null)?"":d1[name];
                        let convertB = (d2[name]===undefined || d2[name]===null)?"":d2[name];
                        if(this.orderSort.type=="asc"){
                            return convertA.localeCompare(convertB);
                        }else{
                            return convertB.localeCompare(convertA);
                        }
                    }
                })
            }
            return list;
        },
        deskFilter(){
			let list=this.reserveDeskList||[];
            if(this.isDeskEmpty){//只看空台
                list=list.filter(it=>it.Desk_Status==0);
            }
            if(this.deskSearchTxt){//检索 客户名称 或 手机号 桌台号
                const text=this.deskSearchTxt.toUpperCase();
                list=list.filter(it=>(it.Cstm_Name||"").toUpperCase().indexOf(text)>=0 || (it.Cstm_Mobile||"").toUpperCase().indexOf(text)>=0 || (it.Desk_Name||"").toUpperCase().indexOf(text)>=0);
            }
            return list;
        },
        sellersList(){
			//销售员信息
			const sellers=[];
			(this.reserveOrderList||[]).forEach(it=>{
				let item=sellers.find(item=>item.User_Name==it.Eat_Sales);
				if(!item){
					item={
						User_ID:it.Eat_Sales,
						User_Name:it.Eat_Sales,
						number:0
					}
					sellers.push(item);
				}
				item.number++;
			})
			return sellers;
		},
        //餐厅数据
        roomGroup(){
            const list=[{text:"全部餐厅",value:""}];
            const group={};
            (this.roomData||[]).forEach(it=>{
                if(it.Room_ID){
                    if(!group[it.Room_ID]){
                        group[it.Room_ID]={
                            text:it.Room_Name,
                            value:it.Room_ID
                        };
                        list.push(group[it.Room_ID])
                    }
                }
            })
            return list;
        },
        //按餐厅分组
        roomGroupList(){
            const group={};
            const groupList=[];
            this.deskFilter.forEach(it=>{
                if(!group[it.Room_ID]){
                    group[it.Room_ID]={
                        Room_ID: it.Room_ID,
                        Room_Name: it.Room_Name,
                        list:[]
                    }
                    groupList.push(group[it.Room_ID])
                }
                group[it.Room_ID].list.push(it);
            })
            return groupList;
        },
        /*当前 时段 数据*/
        phaseInfo() {
            if (this.reserveData && this.reserveData.PhasePeriodStatsList && this.ydPhaseID) {
                return this.reserveData.PhasePeriodStatsList.find(it=>this.ydPhaseID==it.PhaseID);
            }
            return null;
        },
        //预订标题
        ydTitle(){
            let ydDate=new Date(this.ydDate);
            
            return `${ydDate.Format('MM月dd日')} 星期${('日一二三四五六')[ydDate.getDay()]} ${this.phaseInfo?.PhaseName||""}`;
        },
        //勾选桌台的状态  0 空台 1锁台 2预订 3(开台、预结、超时)
        deskOrderType(){
            if(this.cartDeskList.length>0){
                if(this.cartDeskList[0].Is_Desk_Locked){//锁台
                    return 1;
                }else if(this.cartDeskList[0].Desk_Status==0){//空台
                    return 0;
                }else if(this.cartDeskList[0].Desk_Status==2){//预订
                    return 2;
                }else if(([1,3,4]).includes(this.cartDeskList[0].Desk_Status)){
                    return 3;
                }
            }
            return 0;
        },
        //勾选的桌台是否都可预订
        isDeskCheckReserve(){
            if(this.cartDeskList.length>0){
                return !this.cartDeskList.some(it=>!it.IsAllowReserve)
            }
            return true;
        },
        //当前预订日期是否是今天
        isToDate(){
            return this.toDay==this.ydDate;
        },
        //预订默认时间
        phaseTime(){
            if(this.phaseInfo){
                if(this.isToDate){//当天
                    let date=timeToMinutes(new Date().Format("hh:mm"));
                    let startTime=timeToMinutes(this.phaseInfo.StartTime);//开始分钟数
                    let endTime=timeToMinutes(this.phaseInfo.EndTime);//结束分钟数
                    let step= this.phaseInfo.Reserve_Interval||30;

                    if(date<startTime){
                        return  this.formatTime(startTime);
                    }else if(date>endTime){
                        return this.formatTime(endTime-(endTime-startTime)%step);
                    }else{
                        let time=date+(step-(date-startTime)%step);
                        return this.formatTime(time);
                    }
                    
                }else{
                    return this.phaseInfo.StartTime;//默认时段开始时间范围
                }
            }
            return "";
        },
        //当前 时段下 桌台 统计
        deskTypes(){
            let total=[];
            if(this.phaseInfo && this.phaseInfo.PhasePeriodDeskTypes){
                total=(this.phaseInfo.PhasePeriodDeskTypes||[]).map(it=>{
                    return {
                        DeskType_ID:it.DeskType_ID,
                        DeskType_Name:it.DeskType_Name,
                        EmptyTables:0
                    }
                });

                (this.reserveDeskList||[]).forEach(it=>{
                    let item=total.find(item=>item.DeskType_ID==it.ReserveTypeID);
                    if(item && (it.Desk_Status==0 || it.Is_Desk_Locked)){//空台
                        item.EmptyTables++;
                    }
                })
            }
            
            return total;
        },
    },
    watch:{
        //日期变化了
        ydDate(){
            this.loadData();
        },
        //当前分钟数变动了
        DateNow() {
            this.setPhaseTime();
        },
        //默认 6列
        rowNum(newVal){
            this.$cacheData.set("cloudPosPre_rowNum",newVal);//存储
        },
        navIndex(){
            //给桌台打标记
            this.setDeskEditMark();
            if(this.navIndex==1){
                if(this.cartDeskList.some(it=>it.isDisabled)){//有不能预订的 清除
                    this.createCart();
                }

                //来电记录 要默认到未读
                this.$refs.talTecord.defaultNotRead();
            }
        },
        //当前时段 空台统计
        deskTypes(){
            this.phaseInfo?.PhasePeriodDeskTypes?.forEach(it=>{
                this.deskTypes.find(item=>{
                    if(item.DeskType_ID==it.DeskType_ID){
                        it.EmptyTables=item.EmptyTables;
                        return true;
                    }
                })
            })
        }
    },
    mounted() {
        let SysProjects=this.$cacheData.SysProjects.get();
		if(SysProjects && SysProjects.length>0){
			SysProjects.forEach(element=> {
				if(element.Visible){
					let menu=this.navMenu[element.Project_Key];
					if(menu){
						menu.name=element.Project_Name;
						menu.index=element.Project_Index;

						if(element.Project_Key=="CloudPosPre"){
							console.log(element)
							if(element.SysProjectGroups?.length>0){
								this.userNavMenu.push(menu);
							}
						}else{
							this.userNavMenu.push(menu);
						}	
					}
				}
			});
		}
        this.$emit("navIndex", 5);
        this.loadData();
        this.minutesTime();
        //预订推送监听
		this.$mqTTClient.mqCloudPosData(()=>{
			return new Promise((resolve) => {
				resolve({});
			});
		},"ReservePlatform",(d,newData)=>{
			this.deskUpdate(newData);
		})
    },
    beforeUnmount(){//被卸载前调用
        this.$webBrowser.off("ReservePlatform");
    },
    methods: {
        back(){
            if(this.userNavMenu?.length>0){
                const userInfo=this.$auth.getUserInfo(); //获取用户
                let pathname=""
                let fastFood=userInfo.Business_Types.find(it=>it.value!='4');
                if(fastFood){
                    if(fastFood.value=='1'){
                        pathname="fastFoodDetail";
                        
                    }else{
                        pathname="diningTable";
                    }
                }
                if(!pathname && this.userNavMenu.length>1){
                    pathname=this.userNavMenu[1].url;
                }
                if(pathname){
                    this.$router.push('/home/'+pathname);
                    return;
                }
               
            }
        },
        /**最大化 */
		formMax(){
			this.$webBrowser.formMax();
			this.$global.isFull=false;
		},
		/**全屏 */
		formFull(){
			this.$webBrowser.formFull();
			this.$global.isFull=true;
		},
        toggleSort(key){
            if(this.orderSort.key==key){
                this.orderSort.type=this.orderSort.type=='asc'?"desc":'asc';
            }else{
                this.orderSort.key=key;
                this.orderSort.type="desc";
            }
        },
        formatTime(seconds) {
            const hours = parseInt(seconds / 60);
            const minutes = seconds%60;
            // 格式化为两位数
            const formattedHours = hours.toString().padStart(2, '0');
            const formattedMinutes = minutes.toString().padStart(2, '0');
            return `${formattedHours}:${formattedMinutes}`;
        },
        //时间日期 只取 时 分  转换成分钟
        dateToMinutes(date) {
            date=new Date(date);
            
            const hours = date.getHours();
            const minutes = date.getMinutes();
            
            return hours * 60 + minutes;
        },
        //每分钟改变一次
        minutesTime() {
            if (this._mTime) {
                clearTimeout(this._mtime);
            }
            const date = new Date();
            this.DateNow = date;
            let seconds = date.getSeconds(); //秒
            this.setDeskStatus();
            this._mTime = setTimeout(() => {
                this.minutesTime();
            }, (60 - seconds) * 1000);
        },
        //桌台数据变化了
        deskUpdate(data){
            console.log("mq推送",data);
            if(this.reserveData && this.reserveData.PhasePeriodStatsList){//有时段数据
                if(this.phaseInfo.type==1){//已过的不在接收推送
                    return;
                }
                if(data.ReserveEventEnum==18){//客户 vip 标记操作
                    if(data.ReserveOrderInfo){
                        this.reserveDeskList.forEach(desk=>{
                            if(desk.Cstm_AutoID==data.ReserveOrderInfo.Cstm_AutoID){
                                desk.IsVip=data.ReserveOrderInfo.IsVip;//客户是否vip
                            }
                        })
                    }
                }else if(data.ReserveEventEnum==19){//推送 来电信息
                    this.$refs.talTecord?.telUpdate(data.ReserveTels);
                }else if(([1,2,3,4,5,6,7,8,9,10]).includes(data.ReserveEventEnum)){//判断 推送过来的数据是否是预订单操作数据
                    //同预订日期时
                    if(new Date(data.ReserveOrderInfo.Eat_PreDate).Format("yyyy-MM-dd")==this.ydDate){
                        const Eat_PreChildPhaseID=data.ReserveOrderInfo.Eat_PreChildPhaseID;
                        const Eat_PrePhaseID =data.ReserveOrderInfo.Eat_PrePhaseID;
                        //同时段
                        if(this.phaseInfo.PhaseID==Eat_PreChildPhaseID){//时段
                            this.setDeskInfo(data.ReserveOrderInfo,true);
                        }
                    }
                }else{//非预订操作 只针对当前桌台的
                    if(this.phaseInfo.type==2){//当前时段
                        this.setDeskInfo(data.ReserveOrderInfo,true,data.ReserveEventEnum);
                    }
                }
            }
        },
        //清空指定桌台
        createDesk(deskList,phaseID){
            const phaseInfo=this.reserveData.PhasePeriodStatsList.find(it=>it.PhaseID==phaseID);
            deskList.forEach(it=>{
                if(this.phaseID==phaseID){//当前预订时段
                    let index=this.reserveDeskList.findIndex(desk=>desk.Desk_ID==it.Desk_ID);
                    if(index>=0){
                        const desk=this.reserveDeskList[index];
                        this.reserveDeskList[index]={
                            Desk_ID:desk.Desk_ID,
                            Desk_Code:desk.Desk_Code,
                            Desk_Name:desk.Desk_Name,
                            Seat_Numbers:desk.Seat_Numbers,
                            IsAllowReserve:desk.IsAllowReserve,
                            Room_ID: desk.Room_ID,
                            Room_Name: desk.Room_Name,
                            ReserveTypeID:desk.ReserveTypeID,
                            ReserveTypeName:desk.ReserveTypeName,
                            RegionGroupRoomID:desk.RegionGroupRoomID,
                            RegionGroupRoomName:desk.RegionGroupRoomName,
                            Desk_Status:0
                        }
                    }
                }
            })
        },
        //根据预订单数据 更新桌台数据 isToDay=true 不判断日期和时段 eventEnum 操作类型
        setDeskInfo(orderInfo,isToDay,eventEnum){ 
            if(!orderInfo){
                return;
            }
            if(!isToDay){
                //非预订 要判断预订日期
                if(new Date(orderInfo.Eat_PreDate).Format("yyyy-MM-dd")!=this.ydDate){
                    return;
                }
                if(orderInfo.Eat_PreChildPhaseID!=this.phaseInfo.PhaseID){//非当前预订时段
                    return;
                }
            }
           
            const openDeskInfo=orderInfo.OpenReserveDeskInfo;//开台桌台信息
            (orderInfo.ReserveDesks||[]).forEach(desk=>{
                const oldDesk=this.reserveDeskList.find(it=>it.Desk_ID==desk.Eat_DeskID);
               
                if(oldDesk && (!oldDesk.DeskTimestamps || desk.DeskTimestamps>oldDesk.DeskTimestamps)){//按时间戳最新的更新
                    if(eventEnum!=17 && oldDesk.Desk_Status!=0){//非桌台图状态推送
                        if(oldDesk.Desk_Status!=2 && desk.Desk_Status==2){//当前桌台状态非预订 推送过来的是预订数据不更改
                            return;
                        }
                    }
                
                    let newDesk={
                        Desk_ID:desk.Eat_DeskID,
                        Desk_Status:desk.Desk_Status||0,//桌台状态，详情查看下方枚举定义
                        Is_Desk_Locked:false,//	bool	桌台是否锁定
                        Is_VisualDesk:false,//是否虚拟桌台
                        Operate_Time:null,//操作时间
                        Is_ReserveOrder:false,//	是否预订订单
                        Order_ID:"",//	点单ID（非预订订单）
                        Eat_CheckIndex:"",//	结账单号
                        Order_UnionID:"",//	点单联台ID
                        OrderTimestamps:0,//	点单时间戳
                        PersonNum:0,//	人数
                        OpenDesk_Time:null,//	开台时间
                        Eat_SaleMoney:0,//	销售金额
                        Eat_CheckMoney:0,//	结账金额
                        Member_CardKind:"",//会员等级
                        Reserve_OrderID:'',//预订订单ID
                        Reserve_OrderNo:'',	//	预订订单号
                        Reserve_Time:null,//	预订时间
                        Reserve_RptDate:null,//预订日期
                        Reserve_CheckIn_Time:null,//	预计就餐时间
                        Reserve_Operator:'',//预订操作员
                        Reserve_Seller:'',//预订销售员
                        ReserveChannel_ID: "",
                        ReserveChannel_Name: "",
                        XfTypeId:"",
                        XfType_Name:"",
                        Cstm_AutoID:'',//客户ID
                        Cstm_Name:'',//客户姓名
                        Cstm_Sex:true,//客户性别：男/女
                        Cstm_Mobile:'',//客户手机号
                        Client_Habits:"",//喜好
                        Client_Taboo:"",//忌口
                        IsVip:false,//是否VIP
                        IsMember:false,//是否会员
                        isTimeOut:false,
                        DeskTimestamps:desk.DeskTimestamps,//桌台时间戳
                        Status:0,
                        Order_Type:0,//类型
                    }
                    if(newDesk.Desk_Status!=0){//非空台
                        
                        newDesk.Order_ID=orderInfo.Order_ID;//点单ID（非预订订单）
                        newDesk.PersonNum=desk.Eat_ManNum;//	人数
                        newDesk.Reserve_OrderID=orderInfo.Eat_PreAutoID;//预订订单ID
                        newDesk.Reserve_OrderNo=orderInfo.Eat_OrderNo;	//	预订订单号
                        newDesk.Reserve_Time=orderInfo.CreatTime;//	预订时间
                        newDesk.Reserve_RptDate=orderInfo.Eat_PreDate;//预订日期
                        newDesk.Reserve_CheckIn_Time=orderInfo.Eat_PreTime;//	预计就餐时间
                        newDesk.Reserve_Operator=orderInfo.Eat_Sales;//预订操作员
                        newDesk.Reserve_Seller=orderInfo.Eat_Sales;//预订销售员
                        newDesk.Cstm_AutoID=orderInfo.Cstm_AutoID;//客户ID
                        newDesk.Cstm_Name=orderInfo.Cstm_Name;//客户姓名
                        newDesk.Cstm_Sex=orderInfo.Cstm_Sex;//客户性别：男/女
                        newDesk.Cstm_Mobile=orderInfo.Cstm_Mobile;//客户手机号
                        newDesk.Client_Habits=orderInfo.Client_Habits;//喜好
                        newDesk.Client_Taboo=orderInfo.Client_Taboo;//忌口
                        newDesk.IsVip=orderInfo.IsVip;//是否VIP
                        newDesk.IsMember=orderInfo.IsMember;//是否会员
                        if(eventEnum!=17){//状态17 不更改 定金 和 确认状态
                            newDesk.IsDepositReceived=orderInfo.IsDepositReceived;//是否收取订金
                            newDesk.ArrivalConfirmCount=orderInfo.ArrivalConfirmCount;//到店确认状态及其确认次数 =0 待确认 =1次，2次，3次
                        }
                        newDesk.ReserveChannel_ID= orderInfo.ReserveChannel_ID;//订单来源渠道ID
                        newDesk.ReserveChannel_Name=orderInfo.ReserveChannel_Name;
                        newDesk.XfTypeId=orderInfo.XfTypeId;//预定类型
                        newDesk.XfType_Name=orderInfo.XfType_Name;//预定类型
                        newDesk.Status=orderInfo.Status;//订单状态
                        newDesk.Order_Type=orderInfo.Order_Type;//订座类型
                        if(newDesk.Reserve_OrderID){//有预订单id
                            newDesk.Is_ReserveOrder=true;
                        }
                    
                        if(desk.Eat_DeskState==10){//预订 锁定
                            newDesk.Is_Desk_Locked=true;
                            newDesk.Is_ReserveOrder=true;
                            newDesk.Desk_LockedReason=orderInfo.Eat_Bz;
                        }
                        
                        if(openDeskInfo){//开台 才会有信息
                            newDesk.PersonNum=openDeskInfo.Eat_ManNum;
                            newDesk.Member_CardKind=openDeskInfo.Member_CardKind;//会员等级
                        }
                        
                        const date=new Date();
                        if(newDesk.Desk_Status==2 && !newDesk.Is_Desk_Locked && newDesk.Is_ReserveOrder && new Date(newDesk.Reserve_CheckIn_Time)<date){//预订单 超时
                            newDesk.isTimeOut=true;
                            newDesk.timeOut=parseInt((date.getTime()-new Date(newDesk.Reserve_CheckIn_Time).getTime())/1000);
                        }
                        
                    }else{
                        newDesk.IsDepositReceived=false;
                        newDesk.ArrivalConfirmCount=0;
                    }
                
                    //在操作桌台时 给推送数据 打标记
                    this.setDeskEditMark([newDesk]);
                    Object.assign(oldDesk,newDesk);
                }
            });
        },
        //计算桌台超时状态
        setDeskStatus(){
            if(this.isToDate){
                const date=new Date();
                (this.reserveDeskList||[]).forEach(it=>{
                    if(it.Desk_Status==2 && !it.Is_Desk_Locked && it.Is_ReserveOrder && new Date(it.Reserve_CheckIn_Time)<date){//预订单 超时
                        it.isTimeOut=true;
                        it.timeOut=parseInt((date.getTime()-new Date(it.Reserve_CheckIn_Time).getTime())/1000);
                    }else{
                        it.isTimeOut=false;
                        it.timeOut=0;
                    }
                })
            }
        },
        //时间转换成 hh:mm
        timeFormat(date){
            if(!date || date=="0001-01-01T00:00:00"){
                return "";
            }
            return new Date(date).Format("hh:mm");
        },
        blurPhone(phone) {
			if (!phone || phone.length !== 11) return phone;
			return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1**$2');
		},
        //今天
        clickToDay(){
            this.ydDate=this.toDay;
        },
        //农历
        lunarChange(date,lunar){
            this.lunarDate=lunar;
        },
        //预订日期发生变化
        calendarChange(item){
            this.ydDate=item.fulldate;
        },
        //加载数据
        async loadData() {
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            try {
                
                //获取桌台基础数据
                if((this.roomData||[]).length==0){
                    await this.getRoomModels().then(d=>{
                        this.roomData=d;
                    });
                }
                await this.$refs.talTecord?.loadList();
                await this.loadReserveData();
                //await this.loadDayOrders();
            } catch (e) {
                this.$alert((e.message || e),"错误提示");
            }
            loading.close();
        },
        //获取桌台基础数据
        async getRoomModels(){
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            return await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetRoomModels",{
                Department_ID:userInfo.Department_ID
            }).then(d=>{
                if (d.ResponseHeader.ResultCode != 0) {
                    throw {
                        message: d.ResponseHeader.ResultDesc
                    };
                }else{
                    return d.ResponseBody;
                }
            })
        },
        //加载订单数据
		async loadDayOrders(isLoading=false){
			if (this._loadOrder) {
				return;
			}
			this._loadOrder = true;
            let loading=null;
			if (isLoading) {
				loading = this.$loading({
                    text: "加载中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
			}
			const userInfo=this.$auth.getUserInfo(); //获取用户id
			const param={
				User_ID:userInfo.userID,
				Operator_Name:userInfo.Login_Name,
				Search_StarDate:this.ydDate,
				Search_EndDate:this.ydDate
			}
			
			return this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetDayOrders",param).then(d=>{
				this._loadOrder = false;
				if (isLoading) {
					loading?.close();
				}
				if (d.ResponseHeader.ResultCode != 0) {
					this.reserveData = null;
					if (!isLoading) {
						throw {
							message: d.ResponseHeader.ResultDesc
						};
					}
					this.$alert(d.ResponseHeader.ResultDesc, "错误提示");
				}else{
					this.orderList=d.ResponseBody||[];
				}
			}).catch(e => {
				this._loadOrder = false;
				if (!isLoading) {
					throw e;
				}
				loading?.close();
				this.$alert(e.message,'错误提示');
				console.log('请求失败:', e);
			});
		},
        //加载今日预订统计数据
        async loadReserveData(isLoading){
            if(this._loadReserve){//在加载中
                return;
            }
            this._loadReserve=true;
            let loading=null;
            if(isLoading){
                loading = this.$loading({
                    text: "加载中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
           
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            console.log(userInfo)
            return await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetReserveDataView",{
                User_ID:userInfo.userID,
                Department_ID:userInfo.Department_ID,
                QueryDate:this.ydDate,
                Operator_Name:userInfo.Login_Name,
                ViewType:1//0-仅统计，1-包含桌台详情
            }).then(d=>{
                this._loadReserve=false;
                if(isLoading){
                    loading.close();
                }
                if (d.ResponseHeader.ResultCode != 0) {
                    this.reserveData=null;
                    if (!isLoading) {
                        throw {
                            message: d.ResponseHeader.ResultDesc
                        };
                    }
                    this.$alert(d.ResponseHeader.ResultDesc, "错误提示");
                }else{
                    
                    d.ResponseBody?.PhasePeriodStatsList?.forEach(item=>{
                        item.PhasePeriodOrders?.forEach(it=>{
                            it.Cstm_Sex=it.Cstm_Sex=="男";
                        })
                    });
                    this.reserveData=d.ResponseBody;
                    this.setPhaseTime();
                    this.defaultPhase();
                    this.setRoomList();
                }
            }).catch(e => {
                this._loadReserve=false;
                if (!isLoading) {
                    throw e;
                }
                loading.close();
                this.$alert(e.message,'错误提示');
                console.log('请求失败:', e);
            });
        },
        //更新当前时段 状态 1已过 2当前 0无 
        setPhaseTime(){
            if(this.reserveData && this.reserveData.PhasePeriodStatsList){
                const isDay=this.ydDate==new Date().Format("yyyy-MM-dd");
                const date=new Date();
                const dayM=date.getHours()*60+date.getMinutes();
                
                const group={};
                this.reserveData.PhasePeriodStatsList.forEach(item=>{
                    let key=item.PhaseID;
                    if(item.Is_MorePre){//多轮预订
                        key=item.ParentPhaseID;
                    }
                    if(!group[key]){
                        group[key]=[];
                    }
                    group[key].push(item);
                })


                for(let key in group){
                    group[key].forEach((item,index)=>{
                        item.type=0;
                        if(isDay){//断时段是否在当前
                            let startTime=0;
                            let endTime=0;
                            if(item.Is_MorePre){//多轮预订
                                if(group[key].length==1){
                                    startTime=timeToMinutes(item.Base_BTime);
                                    endTime=timeToMinutes(item.Base_ETime);
                                }else{
                                    startTime=timeToMinutes(item.StartTime);//开始分钟数
                                    endTime=timeToMinutes(item.EndTime);//结束分钟数
                                    if(index==0){//多轮 第一条
                                        startTime=timeToMinutes(item.Base_BTime);//开始分钟数
                                    }else if(group[key].length-1==index){//多轮 最后一条
                                        endTime=timeToMinutes(item.Base_BTime);//结束分钟数
                                    }
                                }
                            }else{
                                startTime=timeToMinutes(item.Base_BTime);
                                endTime=timeToMinutes(item.Base_ETime);
                            }
                            if(startTime>endTime){//跨天
                                endTime=timeToMinutes("23:59");
                            }
                            if(endTime<=dayM){//已过
                                item.type=1;
                            }else if(startTime<=dayM && endTime>dayM){//当前
                                item.type=2;
                            }
                        }
                    })
                }
            }
        },
        //默认一个预订时段
        defaultPhase(){
            //默认一个预订时段
            if(this.reserveData && this.reserveData.PhasePeriodStatsList){
                if(!this.phaseInfo){//默认当前时段
                    let item=this.reserveData.PhasePeriodStatsList.find(it=>it.type!=1);
                    if(item){
                        this.ydPhaseID=item.PhaseID;
                    }else{
                        this.ydPhaseID='';
                    }
                }
            }
        },
        //当前门店所有桌台原数据
        setRoomList(){
            
            let phaseDeskOrders=[];//时段下的桌台数据
            if(this.ydPhaseID && this.reserveData && this.reserveData.PhasePeriodStatsList){
                const phaseInfo=this.reserveData.PhasePeriodStatsList.find(it=>it.PhaseID == this.ydPhaseID);
                if(phaseInfo && phaseInfo.PhasePeriodOrders){
                    phaseDeskOrders=phaseInfo.PhasePeriodOrders;
                }
            }
            const list = [];
            (this.roomData||[]).forEach(it => {
                it.ReserveDeskModels.forEach(item => {
                    const deskOrder=phaseDeskOrders.find(order=>order.Desk_ID==item.Desk_ID);
                    list.push(Object.assign({}, item, {
                        Room_ID: it.Room_ID,
                        Room_Name: it.Room_Name,
                        ReserveTypeID:it.ReserveTypeID,
                        ReserveTypeName:it.ReserveTypeName,
                        RegionGroupRoomID:it.RegionGroupRoomID,
                        RegionGroupRoomName:it.RegionGroupRoomName,
                        Desk_Status:0
                    },deskOrder))//
                })
            })
            
            //预订桌台数据
            this.reserveDeskList= list;
            this.setDeskStatus();//超时状态
            //给桌台打标记 
            this.setDeskEditMark();
        },
        //变更时段
        changePhase(item){
            if(this.ydPhaseID!=item.PhaseID){
                this.ydPhaseID=item.PhaseID;
                this.loadReserveData(true);
                this.createCart();
            }
        },
        //查看账单
        orderBill(item){
            // this.$router.push({name: 'billDetail', params:{
            //         id:item.Eat_AutoID,
            //         Rpt_Date:item.Rpt_Date
            //     }
            // });
        },
        //通过订单 勾选桌台
        gouXuanOrderDesk(item){
            if(item.ReserveDesks){
                //清除已选
                this.createCart();
                //清除过滤条件
                this.deskSearchTxt="";
                this.isDeskEmpty=false;

                this.deskFilter.forEach(it=>{
                    if(item.ReserveDesks.some(desk=>desk.Eat_DeskID==it.Desk_ID)){
                        this.addCart(it);
                    }
                })
                this.goScrollAnchor(this.$refs.scroll,".li-box[data-id='"+item.Eat_PreAutoID+"']")
                // Array.from(this.$refs.scroll?.querySelectorAll(".li-box")||[]).find(dom=>{
                //     if(item.ReserveDesks.some(desk=>desk.Eat_DeskID==dom.dataset["id"])){
                //         this.$refs.scroll.scrollTop=dom.offsetTop-this.$refs.scroll.offsetTop;
                //         return true;
                //     }
                // })
            }
        },
        //滚动到 指定锚点
        goScrollAnchor(dom,anchorName){
            let element=dom?.querySelector(anchorName);
            if(element){
                dom.scrollTop=element.offsetTop-dom.offsetTop;
            }
        },
        //选中桌台
        addCart(item,isScroll){
            if(this.editDeskType>0){//桌台操作 换台 或 加台
                if(item.isDisabled){//禁止操作
                    return;
                }
                if(this.editDeskType==2){//加台
                    const index=this.cartDeskList.findIndex(it=>it.Desk_ID==item.Desk_ID);
                    if(index>=0){
                        this.cartDeskList.splice(index,1);
                        delete this.cartDeskCheck[item.Desk_ID];
                    }else{
                        const Desk_ID=this.editDeskData.deskInfo.Desk_ID
                        if(item.Desk_Status==0){//空桌 非同桌
                            this.cartDeskList.push(item);
                            this.cartDeskCheck[item.Desk_ID]=true;
                        }
                    }
                }else if(this.editDeskType==1 && this.editDeskData.deskList.length>1){//预订多台换桌 
                    const index=this.cartDeskList.findIndex(it=>it.Desk_ID==item.Desk_ID);
                    if(index>=0){
                        this.cartDeskList.splice(index,1);
                        delete this.cartDeskCheck[item.Desk_ID];
                    }else {
                        if(this.cartDeskList.length>=this.editDeskData.deskList.length){
                            this.$alert(`您已选择${this.cartDeskList.length}桌，换桌时请选择相同桌数，不可多选或少选！`,'错误提示');
                            return;
                        }
                        const Desk_ID=this.editDeskData.deskInfo.Desk_ID
                        if(item.Desk_Status==0){//空桌 非同桌
                            this.cartDeskList.push(item);
                            this.cartDeskCheck[item.Desk_ID]=true;
                        }
                    }
                }else{
                    this.changeDesk(item);
                }
                return;
            }else if(this.navIndex==1){
                if(item.isDisabled){//禁止操作
                    return;
                }
            }
            const index=this.cartDeskList.findIndex(it=>it.Desk_ID==item.Desk_ID);
            if(index>=0){
                this.cartDeskList.splice(index,1);
                delete this.cartDeskCheck[item.Desk_ID];
                if(this.cartDeskList.length==0){
                    this.isCartShow=false;
                }
            }else{
                if(this.cartDeskList.length>0){
                    if(this.deskOrderType==0 && item.Desk_Status!=0){//空台
                        this.createCart();
                    }else if(this.deskOrderType==2){//预订
                        if(item.Desk_Status!=2){//预订
                            this.createCart();
                        }else if(item.Reserve_OrderID!=this.cartDeskList[0].Reserve_OrderID){//非同一批次
                            this.createCart();
                        }
                    }else if(this.deskOrderType==1){//锁台
                        if(!item.Is_Desk_Locked){//非锁台
                            this.createCart();
                        }else if(item.Reserve_OrderID!=this.cartDeskList[0].Reserve_OrderID){//非同一批次
                            this.createCart();
                        }
                    }else if(this.deskOrderType==3){//(开台、预结、超时) 单选
                        this.createCart();
                    }
                }
                this.cartDeskList.push(item);
                this.cartDeskCheck[item.Desk_ID]=true;

                if(isScroll){
                    this.goScrollAnchor(this.$refs.booking,".booking-item[data-id='"+item.Reserve_OrderID+"']");
                    this.currentOrder=item.Reserve_OrderID;
                }
            }
        },
        //清空勾选
        createCart(){
            this.cartDeskList=[];
            this.cartDeskCheck={};
        },
        //点击预订开台 或 散客开台
        clickOpenDask(type){
            //点单收银
            if(this.userNavMenu?.some(it=>it.Project_Key=="Order")){
                this.$message.warning('无中餐权限,请去门店设备中设置');
                return;
            }
            const userInfo=this.$auth.getUserInfo(); //获取用户
            //0：中餐
            if(!userInfo.Business_Types.some(it=>it.value==0)){
                this.$message.warning('无中餐权限,请去门店设备中设置');
                return;
            }



            if(!this.phaseInfo){
                this.$message.warning('请选择一个时段');
                return;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            if(this.phaseInfo.type!=2){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]非当前时段，无法开台`);
                return;
            }
            if(this.cartDeskList.length==0){
                this.$message.warning("请先选择需要开台的桌台");
                return ;
            }
            this.$router.push({
                name: 'diningTable', params:{
                    reserveData:JSON.stringify(this.cartDeskList.map(it=>{
                        return {
                            Desk_ID:it.Desk_ID,
                            Desk_AutoID:it.Desk_ID,
                            Desk_Code:it.Desk_Code,
                            Desk_Name:it.Desk_Name,
                            Seat_Numbers:it.Seat_Numbers,//标准人数
                        }
                    }))
                }
            });
        },
        /**修改预订单信息*/
        orderEdit(item){
            if(!this.phaseInfo){ 
                this.$message.warning('请选择一个时段');
                return;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            if(item){
                if(!item.Eat_PreAutoID){
                    this.$message.warning('订单非预订单');
                    return;
                }
                this.reserveParam={
                    Eat_PreAutoID:item.Eat_PreAutoID,
                }
            }else{
                if((this.cartDeskList||[]).length==0){
                    this.$message.warning("请先选择需要查看的预订单");
                    return ;
                }
                const Eat_PreAutoID=this.cartDeskList[0].Reserve_OrderID;//预订单id
                this.reserveParam={
                    Eat_PreAutoID:Eat_PreAutoID,
                }
            }
            this.isReserveEdit=true;
        },
        /**创建 预订单 
         * @param data 来源信息
        */
        clickOrder(data){
            if(!this.phaseInfo){ 
                this.$message.warning('请选择一个时段');
                return;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            if(this.cartDeskList.length==0){
                this.$message.warning('请选择要预订的桌台');
                return;
            }
            if(this.cartDeskList.some(it=>!it.IsAllowReserve)){//存在不可预订桌台
                let deskNames=this.cartDeskList.filter(it=>!it.IsAllowReserve).map(it=>it.Desk_Name).join(",")
                this.$message.warning(`[${deskNames}]桌台不可预订`);
                return;
            }
            
            if(this.cartDeskList.some(it=>it.Desk_Status!=0)){
                this.$message.warning(`存在非空桌台不可预订`);
                return;
            }
            
            this.reserveParam={
                ydDate:this.ydDate,//预订日期
                phaseID:this.phaseInfo.PhaseID,//预订时段id
                parentPhaseID:this.phaseInfo.ParentPhaseID,
                phaseName:this.phaseInfo.PhaseName,//时段名称
                phaseTime:this.phaseTime,//预订时间
                Base_BTime:this.phaseInfo.StartTime,//开始分钟数 开始
                Base_ETime:this.phaseInfo.EndTime,//结束分钟数 结束
                Reserve_Interval:this.phaseInfo.Reserve_Interval,//预订间隔时间,单位分钟,默认30分钟
                personNum:this.cartDeskList[0].Seat_Numbers||1,//默认第一个桌台的人数
                deskList:this.cartDeskList.map(it=>{
                    return {
                        Desk_ID:it.Desk_ID,
                        Desk_Name:it.Desk_Name
                    }
                })//选中的桌台数据
            }
            if(data){
                Object.assign(this.reserveParam,{
                    phoneNumber:data.Telnum,//来源电话
                    TelAutoID:data.TelAutoID,//来源id
                })
            }
            this.isReserveEdit=true;
        },
        //预订单 保存成功后 返回
        reserveConfirm(data){
            this.createCart();
            this.setDeskInfo(data);
            if(this.reserveParam.Eat_PreAutoID){//修改

            }else{//新增
                
                if(this.reserveParam.TelAutoID){//刷新 电话记录 明细数据
                    this.$refs.talTecord?.refreshInfoDetail();
                }
            }
        },
        //锁台
        lockDesk(){
            if(!this.ydDate){
                this.$message.warning("请先选择预订日期");
                return ;
            }
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            
            if(this.cartDeskList.length==0){
                this.$message.warning("请先选择需要锁台的桌台");
                return ;
            }
            //this.closeMore();
            this.reasonTitle="请输入锁台原因";
            this.$refs.reason.open();
            this.$refs.reason.cllBack((text)=>{
                if(!text){
                    this.$message.warning("请选输入锁台原因");
                    return false;
                }
                if(this._load){
                    return;
                }
                this._load=true;
                const userInfo=this.$auth.getUserInfo(); //获取用户id
                const param={
                    User_ID: userInfo.User_ID,
                    Operator_Name: userInfo.Login_Name,
                    Eat_PreChildPhaseID:this.phaseInfo.PhaseID,//用餐轮次ID
                    Eat_PrePhaseID:this.phaseInfo.ParentPhaseID,//用餐时段ID
                    Eat_PreDate:this.ydDate,
                    Eat_PreTime:new Date().Format("yyyy-MM-dd hh:mm:ss"),
                    Lock_Reason:text.trim(),//锁台原因
                    Eat_DeskIDs:this.cartDeskList.map(it=>it.Desk_ID),//锁台桌台ID列表
                }
                const loading = this.$loading({
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$httpAES.reservePost("Bestech.CloudPos.Reserve.LockDesk", param).then(d => {
                    this._load=false;
                    loading.close();
                    if (d.ResponseHeader.ResultCode != 0) {
                        this.$message.error(d.ResponseHeader.ResultDesc);
                    } else {
                        if(d.ResponseBody){
                            this.setDeskInfo(d.ResponseBody);
                        }
                        this.createCart();
                        //this.closeMore();
                    }
                }).catch(e => {
                    this._load=false;
                    loading.close();
                    this.$message.error(e.message);
                    console.log('请求失败:', e);
                });
            })
        },
        //解锁
        unLockDesk(){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.cartDeskList[0].Reserve_OrderID,//预订单id
                Eat_DeskIDs:this.cartDeskList.map(it=>it.Desk_ID),//锁台桌台ID列表
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.UnLockDesk", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        this.setDeskInfo(d.ResponseBody);
                    }
                    this.createCart();
                }
            }).catch(e => {
                this._load=false;
                this.hideLoading();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //退订
        cancelReserve(item){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`[${this.phaseInfo.PhaseName}]时段已过`);
                return;
            }
            if(item){
                if(!item.Eat_PreAutoID){
                    this.$message.warning("非预订单不能退订");
                    return ;
                }
            }else{
                if(this.cartDeskList.length==0){
                    this.$message.warning("请先选择需要退订的桌台");
                    return ;
                }
            }
            //this.closeMore();
            this.$refs.cancel.open();
            this.$refs.cancel.cllBack((text)=>{
                if(!text){
                    this.$message.warning("请先输入退订原因");
                    return false;
                }
                if(this._load){
                    return;
                }
                this._load=true;
                const userInfo=this.$auth.getUserInfo(); //获取用户id
                const param={
                    User_ID: userInfo.User_ID,
                    Operator_Name: userInfo.Login_Name
                }
                if(item){
                    param.CancelPreInfos=[ {
                        Eat_PreAutoID:item.Eat_PreAutoID,
                        Eat_DeskIDs:item.ReserveDesks.map(it=>it.Eat_DeskID),//退订桌台ID列表
                        CancelReason:text//退订原因
                    }]
                }else{
                    param.CancelPreInfos=[{
                        Eat_PreAutoID:this.cartDeskList[0].Reserve_OrderID,
                        Eat_DeskIDs:this.cartDeskList.map(it=>it.Desk_ID),//退订桌台ID列表
                        CancelReason:text//退订原因
                    }]
                }
                const loading = this.$loading({
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$httpAES.reservePost("Bestech.CloudPos.Reserve.CancelReserve", param).then(d => {
                    this._load=false;
                    loading.close();
                    if (d.ResponseHeader.ResultCode != 0) {
                        this.$message.error(d.ResponseHeader.ResultDesc);
                    } else {
                        
                        if(d.ResponseBody){
                            this.setDeskInfo(d.ResponseBody);
                        }
                        
                        this.createCart();
                        //this.closeMore();
                    }
                }).catch(e => {
                    this._load=false;
                    loading.close();
                    this.$message.error(e.message);
                    console.log('请求失败:', e);
                });
            })
        },
        //预订单餐前确认接口
        confirmBeforeMeal(item){
            if(item){
                if(!item.Eat_PreAutoID){
                    this.$message.warning("非预订单");
                    return ;
                }
            }
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`${this.phaseInfo.PhaseName}时段已过`);
                return;
            }
            if(this._load){
                return;
            }
            this._load=true;
            //this.closeMore();
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name
            }
            if(item){
                param.Eat_PreAutoID=item.Eat_PreAutoID;//预订单id
            }else{
                param.Eat_PreAutoID=this.cartDeskList[0].Reserve_OrderID;//预订单id
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.ConfirmBeforeMeal", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        this.setDeskInfo(d.ResponseBody);
                    }
                    this.createCart();
                }
            }).catch(e => {
                this._load=false;
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //标记vip
        markVip(isVip,item){
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                
            }
            if(item){
                param.Client_ID=item.Cstm_AutoID
            }else{
                if((this.cartDeskList||[]).length==0){
                    this.$message.warning("请先选择需要操作的桌台");
                    return ;
                }
                param.Client_ID=this.cartDeskList[0].Cstm_AutoID;//客户ID
            }

            let methodName="Bestech.CloudPos.Reserve.CancelMarkClientVIP";
            if(isVip){//标记vip
                methodName="Bestech.CloudPos.Reserve.MarkClientVIP";
            }
            
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost(methodName, param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    (this.reserveDeskList||[]).forEach(it=>{
                        if(it.Cstm_AutoID==param.Client_ID){
                            it.IsVip=isVip;
                        }
                    });
                    this.createCart();
                }
            }).catch(e => {
                this._load=false;
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //桌台操作 1预订换桌 2预订加桌 3开台换桌
        deskEdit(type){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`${this.phaseInfo.PhaseName}时段已过`);
                return;
            }
            if((this.cartDeskList||[]).length==0){
                this.$message.warning("请先选择需要操作的桌台");
                return ;
            }
            if((this.cartDeskList||[]).length>1){
                if(type==2){
                    this.$message.warning("加桌仅支持单桌操作，请选择一张桌台后重试！");
                    return;
                }else if(type==3){//开台换桌 只能单桌
                    this.$message.warning("换桌仅支持单桌操作，请选择一张桌台后重试！");
                    return;
                }
            }
            this.editDeskType=type;
            this.editDeskData={
                ydDate:this.ydDate,
                phaseID:this.phaseID,
                deskInfo:this.cartDeskList[0],
                deskList:this.cartDeskList,//多台 换台
            };
            this.setDeskEditMark();
            this.createCart();
        },
        //放弃操作
        cancelEdit(){
            this.editDeskType=null;
            this.editDeskData=null;
            //去除标记
            this.setDeskEditMark();
            this.createCart();
        },
        //给桌台打标记
        setDeskEditMark(deskList){
            let list=deskList||this.reserveDeskList||[];
            if(this.editDeskData){//打标记
                list.forEach(it=>{
                    //换台加台 操作 标记  禁止操作
                    it.isDisabled=true;
                })
                let deskInfo=this.editDeskData.deskInfo;
                let ydDate=this.editDeskData.ydDate;
                let phaseID=this.editDeskData.phaseID;
                //1 预订换桌 同天同时段 空台(未锁)、预订台  非同时段 空台(未锁)
                if(this.editDeskType==1){
                    if(this.phaseID==phaseID && this.ydDate==ydDate){//同天 同时段
                        if((this.editDeskData.deskList||[]).length>1){//必须是可以预订的 多台换台
                            list=list.filter(it=>it.IsAllowReserve && it.Reserve_OrderID!=deskInfo.Reserve_OrderID //排除同批次预订单
                                && it.Desk_Status==0
                            );
                        }else{
                            //必须是可以预订的
                            list=list.filter(it=>it.IsAllowReserve && it.Reserve_OrderID!=deskInfo.Reserve_OrderID //排除同批次预订单
                                && (it.Desk_Status==0 || (it.Desk_Status==2 && !it.Is_Desk_Locked))
                            );
                        }
                    }else{
                        list=list.filter(it=>it.Desk_Status==0);
                    }
                }else if(this.editDeskType==2){//2 预订加桌 只能同天同时段 空台(未锁)
                    list=list.filter(it=>it.IsAllowReserve && it.Desk_Status==0 && it.Reserve_OrderID!=deskInfo.Reserve_OrderID);
                }else{//3 开台换桌 只能同天同时段 空台(未锁)、预订台
                    if(deskInfo.Is_ReserveOrder){//预订开台的换台 可与预订台换
                        list=list.filter(it=>
                            it.IsAllowReserve && it.Desk_ID!=deskInfo.Desk_ID 
                            && (it.Desk_Status==0 || (it.Desk_Status==2 && !it.Is_Desk_Locked))
                        );
                    }else{//散客换台  只能空台(未锁)
                        list=list.filter(it=>it.Desk_ID!=deskInfo.Desk_ID && it.Desk_Status==0);
                    }
                }
                list.forEach(it=>{
                    //是否可 换台加台 操作 标记
                    it.isDisabled=false;
                })
            }else if(this.navIndex==1){//电话记录
                //必须是 可以预订的 并且是空台的
                list.forEach(it=>{
                    if(it.IsAllowReserve && it.Desk_Status==0){
                        it.isDisabled=false;
                    }else{
                        it.isDisabled=true;
                    }
                })
            }else{//取消标记
                list.forEach(it=>{
                    //换台加台 操作 标记  禁止操作
                    it.isDisabled=false;
                })
            }
        },
        //换桌
        changeDesk(item){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`${this.phaseInfo.PhaseName}时段已过`);
                return;
            }
            if(this.editDeskType==3 && !this.editDeskData.deskInfo.Reserve_OrderID){//非预订单开台 换台
                this.walkinChangeDesk(item);
                return;
            }
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.editDeskData.deskInfo.Reserve_OrderID,//预订单id
                ThisDeskID:this.editDeskData.deskInfo.Desk_ID,//本桌台ID（需要换掉的桌台）
                TargetDeskID:item.Desk_ID,//目标桌台ID（换到的桌台）
                Eat_PreDate:this.ydDate,//目标桌台 用餐日期
                Eat_PreTime:this.ydDate+" "+this.phaseTime+":00",//目标桌台 到达时间
                Eat_PrePhaseID:this.phaseInfo.ParentPhaseID,//目标桌台 时段ID
                Eat_PreChildPhaseID:this.phaseInfo.PhaseID//目标桌台 轮次ID
            }
            
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.ChangeReserveDesk", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        d.ResponseBody.forEach(it=>{
                            this.setDeskInfo(it);
                        })
                        
                    }
                    this.cancelEdit();
                }
            }).catch(e => {
                this._load=false;
                this.hideLoading();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //批量预订换桌
        batChangeDesk(){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`${this.phaseInfo.PhaseName}时段已过`);
                return;
            }
            if((this.cartDeskList||[]).length==0){
                this.$message.warning("请先选择需要操作的桌台");
                return ;
            }
            if(this.cartDeskList.length!=this.editDeskData.deskList.length){
                this.$message.warning(`您已选择${this.cartDeskList.length}桌，换桌时请选择相同桌数，不可多选或少选！`);
                return ;
            }
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.editDeskData.deskInfo.Reserve_OrderID,//预订单id
                ThisDeskIDs:this.editDeskData.deskList.map(it=>it.Desk_ID),//原桌台ID列表，（需要换掉的桌台）
                TargetDeskIDs:this.cartDeskList.map(it=>it.Desk_ID),//目标桌台ID列表（换到的桌台）
                Eat_PreDate:this.ydDate,//目标桌台 用餐日期
                Eat_PreTime:this.ydDate+" "+this.phaseTime+":00",//目标桌台 到达时间
                Eat_PrePhaseID:this.phaseInfo.ParentPhaseID,//目标桌台 时段ID
                Eat_PreChildPhaseID:this.phaseInfo.PhaseID//目标桌台 轮次ID
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.ChangeReserveDesks", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        d.ResponseBody.forEach(it=>{
                            this.setDeskInfo(it);
                        })
                        
                    }
                    // //换台时段 日期相同 换空台时 清空原本桌台
                    // if(this.editDeskData.ydDate==this.ydDate && this.editDeskData.phaseID==this.phaseInfo.PhaseID){
                    // 	this.createDesk(this.editDeskData.deskList,this.editDeskData.phaseID);
                    // }
                    this.cancelEdit();
                }
            }).catch(e => {
                this._load=false;
                this.hideLoading();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //散客换台
        walkinChangeDesk(item){
            if(this.editDeskData.ydDate!=this.ydDate){
                this.$message.warning("非当天不可换台");
                return;
            }
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.editDeskData.deskInfo.Reserve_OrderID,//预订单id
                ThisDeskID:this.editDeskData.deskInfo.Desk_ID,//本桌台ID（需要换掉的桌台）
                TargetDeskID:item.Desk_ID,//目标桌台ID（换到的桌台）
                Eat_OrderID:this.editDeskData.deskInfo.Order_ID,//订单ID
                Rpt_Date:this.ydDate,//营业日期
                Eat_PreDate:this.ydDate,//目标桌台 用餐日期
                Eat_PreTime:this.ydDate+" "+this.phaseTime+":00",//目标桌台 到达时间
                Eat_PrePhaseID:this.phaseInfo.ParentPhaseID,//目标桌台 时段ID
                Eat_PreChildPhaseID:this.phaseInfo.PhaseID//目标桌台 轮次ID
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.WalkinChangeDesk", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        this.setDeskInfo(d.ResponseBody);
                    }
                    // //当天 换台 清空原本桌台
                    // if(this.editDeskData.ydDate==this.ydDate){
                    // 	this.createDesk([this.editDeskData.deskInfo],this.editDeskData.phaseID);
                    // }
                    this.cancelEdit();
                }
            }).catch(e => {
                this._load=false;
                this.hideLoading();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //加桌
        addReserveDesk(){
            if(!this.phaseInfo){
                this.$message.warning("请先选择预订时段");
                return ;
            }
            if(this.phaseInfo.type==1){
                this.$message.warning(`${this.phaseInfo.PhaseName}时段已过`);
                return;
            }
            if((this.cartDeskList||[]).length==0){
                 this.$message.warning("请先选择需要操作的桌台");
                return ;
            }
            if(this._load){
                return;
            }
            this._load=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.editDeskData.deskInfo.Reserve_OrderID,//预订单id
                DeskIDs:this.cartDeskList.map(it=>it.Desk_ID),//新加桌台ID列表
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.AddReserveDesk", param).then(d => {
                this._load=false;
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    if(d.ResponseBody){
                        this.setDeskInfo(d.ResponseBody);
                    }
                    this.cancelEdit();
                }
            }).catch(e => {
                this._load=false;
                this.hideLoading();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
    }
}
</script>

<style lang="scss">
	@import './cloudPosPre.scss'
</style>
